import { makeEnum } from '@transcend-io/type-utils';

export const ProfileOrderField = makeEnum({
  /** The ID of the profile */
  id: 'id',
  /** The date the profile was created */
  createdAt: 'createdAt',
});
